import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import * as moment from "moment";

import { ActionPlanResponseAttachmentService } from "../../shared/service/action-plan-response-attachment.service";
import { ActionPlanResponseService } from "../../shared/service/action-plan-response.service";
import { ActionPlanResponseModel } from "../../shared/model/action-plan-response.model";
import { ConfirmComponent } from "../../shared/component/confirm/confirm.component";
import { MessageComponent } from "../../shared/component/message/message.component";
import { ActionPlanService } from "../../shared/service/action-plan.service";
import { ActionPlanModel } from "../../shared/model/action-plan.model";
import { UserService } from "../../shared/service/user.service";
import { UserModel } from "../../shared/model/user.model";

const loadingGif = '/assets/layout/images/preloader.gif';
const actionPlanDir = '/action-plan-attachment/';

@Component({
  selector: "app-action-plan-modal",
  templateUrl: "./action-plan-modal.component.html",
  styleUrls: ["./action-plan-modal.component.css"],
})
export class ActionPlanModalComponent implements OnInit {
  @Output() done = new EventEmitter<void>();

  @ViewChild(ConfirmComponent) confirm: ConfirmComponent;
  @ViewChild(MessageComponent) message: MessageComponent;

  display = false;
  actionPlan = new ActionPlanModel();
  answerForm = new ActionPlanResponseModel({});
  uploadPath: string = localStorage.getItem("apiIP") + "/upload";

  actionPlanResponses;
  answered: Boolean = false;
  answering: Boolean = false;

  lists = [];
  values = [];
  attachments = [];

  users;
  files;

  constructor(
    private router: Router,
    private userService: UserService,
    private translateService: TranslateService,
    private actionPlanService: ActionPlanService,
    private actionPlanResponseService: ActionPlanResponseService,
    private actionPlanAttachment: ActionPlanResponseAttachmentService
  ) {}

  ngOnInit() {
    // this.getListAndValues();
  }

  closeModal() {
    this.display = false;
  }

  goToReportURL(): void {
    const urlTree = this.router.createUrlTree(['checklist-answered', this.actionPlan.checklist_response_id]);
    const relativeUrl = this.router.serializeUrl(urlTree);
    const baseUrl = window.location.origin;
  
    window.open(
      baseUrl + '/#' + relativeUrl,
      '_blank'
    );
  }

  getListValue(item) {
    const value = this.values.find((list) => list.id == parseInt(item.response));
    if (item.header_item && item.header_item.list_id && value && value.description)
    return value.description; else return item.response;
  }

  formatHeaderItems(header_item_responses = []) {
    let responseString = "";

    for (const hir of header_item_responses) {
      let fullResponse = hir.response || "N/A";

      // validation for list type
      if (hir.header_item && hir.header_item.list_id) {
        const value = this.values.find((list) => list.id == hir.response);
        if (value && value.description) fullResponse = value && value.description || "N/A";
      }

      responseString += `${hir.header_item.description}: ${fullResponse}; `;
    }

    return responseString;
  }

  formatDate = (date) => moment(date).format("DD/MM/YYYY HH:mm");

  existAttachments = ({attachments}) => attachments && attachments.length;

  getAttachmentDir({generated_name, compressed}) {
    let attachment = loadingGif;

    if (generated_name) {
      const [folder, _] = generated_name.split('.');
      attachment = `${this.uploadPath}${actionPlanDir}${folder}/${compressed ? 'COMPRESSED.jpg' : generated_name}`;
    }

    return attachment;
  }

  // A partir da linha abaixo não me responsabilizo por bugs, devido código do antigo dev
  initializeForm() {
    const uncoDescription = this.actionPlan.question_response.unconformity ?
    ` / ${this.actionPlan.question_response.unconformity.description}`:'';

    return this.answerForm = {
      what: this.actionPlan.question.description + uncoDescription,
      when: new Date()
    } as ActionPlanResponseModel
  };

  downloadAttachments(attachments) {
    attachments.forEach((element) => {
      this.downloadAttachment(element);
    });
  }

  downloadAttachment(attachment) {
    this.actionPlanAttachment
      .downloadAttachment(attachment.id)
      .subscribe((res) => {
        this.downloadFile(res, attachment.type, attachment.name);
      });
  }

  downloadFile(data: any, type: string, name: string) {
    let blob = new Blob([data], { type: type }),
      url = window.URL.createObjectURL(blob),
      a = document.createElement("a");
    document.body.appendChild(a);
    a.className = "download";
    a.href = url;
    a.download = name + type;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  loadActionPlanData() {

    this.actionPlanResponseService
      .getByActionPlan(this.actionPlan.id)
      .subscribe((res) => {
        this.actionPlanResponses = res.map(({ when, created_at, ...otherProps }) => {
          this.attachments = [...this.attachments, ...otherProps.attachments];
          return { when: this.formatDate(when), created_at: this.formatDate(created_at), ...otherProps };
        });
        // console.log(this.actionPlanResponses)
        if (res && res.length > 0) {
          let { user, when, ...otherProps } = res[res.length - 1];

          this.answerForm = {
            ...otherProps,
            when: new Date(),
            user: new UserModel(),
          } as ActionPlanResponseModel;
        } else this.initializeForm()
      });

      this.formatActionPlanData()
  }

  deleteAnswer (answer) {
    this.actionPlanResponseService.delete(answer.id).subscribe(() => {
      this.message.success(this.translate('answer_deleted_successfully'));
      this.loadActionPlanData()
    })
  }

  formatActionPlanData () {
    // this.actionPlan.
  }

  createAnswer() {
    if (this.actionPlan.responses) {
      if (!this.actionPlan.responses.length)
      this.actionPlan.responses = [];
    } else this.actionPlan.responses = [];

    this.message.fixedInfo(this.translate('saving_answer'));

    this.actionPlanResponseService
      .createAnswer(this.actionPlan.id, this.answerForm)
      .pipe(take(1))
      .subscribe((res: ActionPlanResponseModel) => {
        this.message.clear();

        // Adicionado para atualizar o responsavel ao criar uma resposta
        if (res) {
          res.user = this.answerForm.user;
          res.when = this.formatDate(res.when) as any;
          res.created_at = this.formatDate(res.created_at) as any;

          this.actionPlanResponses = [...this.actionPlanResponses, res];

          if (res.action_plan_id && res.who) {
            this.actionPlanService.updateResponsible(res.action_plan_id, res.who)
            .pipe(take(1)).subscribe(_ => this.message.success(this.translate('responsible_updated')));
          }
  
          if (this.files && this.files.length > 0)
          this.createAttachment(res);

          this.message.success();
          this.initializeForm();
        }
      }, (err) => {
        this.message.clear();
        this.message.error(this.translate('need_more_data'));
      });
  }

  doneActionPlan() {
    this.initializeForm();
    this.confirm.confirm();
  }

  loadUsers() {
    this.userService.getAll().subscribe((res) => {
      this.users = res.map((item) => {
        return { value: item.id, ...item };
      });
    });
  }

  enableAnswer() {
    this.answering = true;
    this.loadUsers();
  }

  onSelect(e) {
    let newFiles = [];
    if (e.files)
      Array.from(e.files).forEach((item: Blob | any, i, arr) => {
        // console.log(item)
        const reader = new FileReader();
        reader.readAsDataURL(item);
        reader.onload = () => {
          newFiles.push({
            base64: reader.result,
            type: item.type.length > 0 ? item.type : item.name.split('.').pop(),
            name: item.name,
            size:  item.size ,
          });
          // return res.result
          return;
        };
        if (arr.length - 1 === i) this.files = newFiles;
      });
    // this.files = e.files
  }

  createAttachment(actionResponse) {
    // let data = new FormData()
    // console.log(this.files)
    // data.append('images', this.files)
    // const reader = new FileReader()
    // reader.readAsDataURL(this.files[0])
    // reader.onload = () => {
    //   console.log(reader.result)
    //   // return res.result
    //   return
    // }
    this.message.fixedInfo(this.translate('saving_attachments'));;
    this.actionPlanAttachment
      .createAttachment({
        action_plan_id: this.actionPlan.id,
        action_plan_response_id: actionResponse.id,
        files: this.files,
      })
      .subscribe((res) => {
        this.message.clear();
        this.loadActionPlanData();
        return this.message.success();
      });
  }

  acceptDoneActionPlan() {
    this.actionPlanService
      .doneActionPlan(this.actionPlan.id)
      .subscribe((data) => {
        this.done.emit();
      });
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/action-plan/action-plan-modal/action-plan-modal.component.ts